import React, { useContext } from "react";
import { MemoContext } from "../contexts/MemoContext";
import { useHistory } from "react-router-dom";
import DashItem from "./sideritems/DashItem";
import FavItem from "./sideritems/FavItem";
import Categories from "./sideritems/Categories";
import AnalItem from "./sideritems/AnalItem";

const SiderNav = () => {
  const history = useHistory();
  const { length } = useContext(MemoContext);
  return (
    <div className="w-4/12 xl:w-1/4 min-h-screen bg-white shadow-sm border-r border-gray-200 hidden lg:flex flex-col px-4">
      <div
        style={{ height: "5.5rem" }}
        className="flex justify-center items-center w-full mb-1"
      >
        <p
          onClick={() => {
            if (history.location.pathname !== "/dashboard") {
              history.push("/");
            }
          }}
          className="cursor-pointer text-4xl m-0 p-0 text-blue-400 font-bold"
        >
          MEMMiFシ
        </p>
      </div>
      <DashItem count={length} />
      <FavItem />
      <AnalItem />
      <Categories />
    </div>
  );
};

export default SiderNav;
